import { Box } from '@material-ui/core'
import { InicialPageSearchProps } from '../inicial-page-search/inicial-page-search-props';
import { useCallback, useEffect, useState } from 'react';
import { ApiListModel } from 'model/api/api-list-model/api-list-model';
import { TransferenciaListModel } from 'model/api/gestao/transferencia/transferencia-list-model';
import { isFalseUndefinedNull } from 'utils/check-type';
import { useToastSaurus } from 'services/app';
import { Paginacao } from 'views/components/paginacao';
import { useEventTools } from 'services/app/use-cases/events/event-tools';
import { useStyles } from './transferencia-list-styles';
import { useCadastros } from 'services/app/hooks/cadastros';
import { TransferenciaListData } from './transferencia-list-data';
import { InfoTransferencias } from '../info-transferencias/info-transferencias';
import { AppEventEnum } from 'model/enums/enum-event-app';
import { useGetTransferencia } from 'data/api/gestao/transferencia/get-transferencia';

interface TransferenciaListProps {
    searchProps: InicialPageSearchProps;
}

export const TransferenciaList = ({ searchProps }: TransferenciaListProps) => {
    const classes = useStyles();
    const [queryList, setQueryList] = useState<ApiListModel<TransferenciaListModel>>({
        list: [],
        pageIndex: 1,
        pageSize: 0,
        totalPages: 0,
        totalResults: 0
    })

    const { getTransferencia, carregando } = useGetTransferencia();

    const { showToast } = useToastSaurus();
    const { addHandler, removeHandler } = useEventTools();

    const { abrirDialogTransferencia } = useCadastros();


    const search = useCallback(async (page: number) => {
        try {

            const query = new URLSearchParams();

            if (!isFalseUndefinedNull(searchProps.dataInicial)) {
                query.append('dInicial', searchProps.dataInicial)
            }

            if (!isFalseUndefinedNull(searchProps.dataFinal)) {
                query.append('dFinal', searchProps.dataFinal)
            }

            query.append('Page', page.toString())
            query.append('PageSize', '30')

            const res = await getTransferencia(query.toString())

            if (res.erro) {
                throw res.erro
            }

            if (!res.resultado?.data) {
                throw new Error('Erro ao listar boletos. Tente novamente.')
            }

            if (
                res.resultado?.data.pageIndex > res.resultado?.data.totalPages &&
                res.resultado?.data.totalResults > 0
            ) {
                search(res.resultado.data.totalPages);
                return;
            }

            if (res.resultado.data.list.length > 0) {
                setQueryList(res.resultado.data)
            }


        } catch (e: any) {
            showToast('error', e.message)
        }
    }, [getTransferencia, searchProps.dataFinal, searchProps.dataInicial, showToast])

    const pageChanged = useCallback(
        async (newPage: number) => {
            if (newPage <= queryList.totalPages || newPage > 0) {
                search(newPage);
            }
        },
        [queryList.totalPages, search]
    );

    useEffect(() => {
        search(1)
    }, [search])

    useEffect(() => {
        const searchCallback = ({ aberto }: any) => {
            if (!aberto) {
                search(queryList.pageIndex);
            }
        }
        addHandler(AppEventEnum.DialogTransferencia, searchCallback)
        return () => {
            removeHandler(AppEventEnum.DialogTransferencia, searchCallback)
        }
    }, [addHandler, queryList.pageIndex, removeHandler, search])

    const onCardClick = useCallback((model: TransferenciaListModel) => {
        abrirDialogTransferencia(model.id)
    }, [abrirDialogTransferencia])


    return (
        <>
            <Box className={classes.defaultContainer}>
                <Box className={classes.list}>
                    <Paginacao
                        pageChanged={pageChanged}
                        totalPages={queryList.totalPages}
                        totalRegisters={queryList.totalResults}
                        currentPage={queryList.pageIndex}
                    />
                    <Box className={classes.listData}>
                        <TransferenciaListData
                            carregando={carregando}
                            list={queryList.list}
                            onCardClick={onCardClick}
                        />
                    </Box>
                    <InfoTransferencias transferencias={queryList.list} />
                </Box>
            </Box>


        </>
    )
}
